import React from 'react'
import PropTypes from 'prop-types'

import { SurfaceWaterDescription } from './layers/surface-water'
import { GroundWaterDescription } from './layers/ground-water'
import { UtilityDescription } from './layers/utilities'
import { WaterTreatmentPlantDescription } from './layers/water-treatment-plants'
import { WasteWaterTreatmentPlantDescription } from './layers/waste-water-treatment-plants'
import { DamDescription } from './layers/dams'
import { WellDescription } from './layers/wells'
import { ReservoirDescription } from './layers/reservoirs'
import { CarrierDescription } from './layers/carriers'
import { ProjectDescriptionWrapper } from './ProjectDescription.styles'

const Description = ({ activeLayer, content, lang }) => {
  switch (activeLayer) {
    case 'surface':
      return <SurfaceWaterDescription {...content} lang={lang} />
    case 'groundwater':
      return <GroundWaterDescription {...content} lang={lang} />
    case 'utilities':
      return <UtilityDescription {...content} lang={lang} />
    case 'water-treatment-plants':
      return <WaterTreatmentPlantDescription {...content} lang={lang} />
    case 'waste-water-treatment-plants':
      return <WasteWaterTreatmentPlantDescription {...content} lang={lang} />
    case 'dams':
      return <DamDescription {...content} lang={lang} />
    case 'reservoirs':
      return <ReservoirDescription {...content} lang={lang} />
    case 'wells':
      return <WellDescription {...content} lang={lang} />
    case 'carriers':
      return <CarrierDescription {...content} lang={lang} />
    default:
      return <div>no supported template for selected resource</div>
  }
}

Description.propTypes = {
  content: PropTypes.object,
  activeLayer: PropTypes.string,
  lang: PropTypes.string
}

const ProjectDescription = ({ lang, activeLayer, activeProject, data }) => {
  const activeLayerData = data.find(({ id }) => id === activeLayer)

  const content =
    activeProject &&
    activeLayerData.entries.find(({ id }) => id === activeProject.id)

  return content ? (
    <ProjectDescriptionWrapper className="resource-description">
      <Description activeLayer={activeLayer} content={content} lang={lang} />
    </ProjectDescriptionWrapper>
  ) : null
}

ProjectDescription.propTypes = {
  data: PropTypes.array,
  activeProject: PropTypes.object,
  activeLayer: PropTypes.string,
  lang: PropTypes.string
}

export default ProjectDescription
